import _regeneratorRuntime from "D:\\a\\1\\s\\AMRS\\AMRS.Web\\ClientApp\\node_modules\\@babel\\runtime-corejs2/regenerator";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "D:\\a\\1\\s\\AMRS\\AMRS.Web\\ClientApp\\node_modules\\@babel\\runtime-corejs2/helpers/asyncToGenerator";
import _classCallCheck from "D:\\a\\1\\s\\AMRS\\AMRS.Web\\ClientApp\\node_modules\\@babel\\runtime-corejs2/helpers/classCallCheck";
import _createClass from "D:\\a\\1\\s\\AMRS\\AMRS.Web\\ClientApp\\node_modules\\@babel\\runtime-corejs2/helpers/createClass";
import _possibleConstructorReturn from "D:\\a\\1\\s\\AMRS\\AMRS.Web\\ClientApp\\node_modules\\@babel\\runtime-corejs2/helpers/possibleConstructorReturn";
import _getPrototypeOf from "D:\\a\\1\\s\\AMRS\\AMRS.Web\\ClientApp\\node_modules\\@babel\\runtime-corejs2/helpers/getPrototypeOf";
import _inherits from "D:\\a\\1\\s\\AMRS\\AMRS.Web\\ClientApp\\node_modules\\@babel\\runtime-corejs2/helpers/inherits";
import axios from "axios";
import BaseData from "./BaseData";

var VawaRequest =
/*#__PURE__*/
function (_BaseData) {
  _inherits(VawaRequest, _BaseData);

  function VawaRequest() {
    _classCallCheck(this, VawaRequest);

    return _possibleConstructorReturn(this, _getPrototypeOf(VawaRequest).call(this, "VawaRequest"));
  }

  _createClass(VawaRequest, [{
    key: "GetOccupancyRequests",
    value: function () {
      var _GetOccupancyRequests = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee(ProjectOccupancyId) {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                return _context.abrupt("return", axios.get("/api/".concat(this._controller, "/GetOccupancyRequests/").concat(ProjectOccupancyId)));

              case 1:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function GetOccupancyRequests(_x) {
        return _GetOccupancyRequests.apply(this, arguments);
      }

      return GetOccupancyRequests;
    }()
  }, {
    key: "SendIneligibleTransferEmail",
    value: function () {
      var _SendIneligibleTransferEmail = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee2(projectId, projectOccupancyId) {
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                return _context2.abrupt("return", axios.post("/api/".concat(this._controller, "/SendIneligibleTransferEmail/").concat(projectId, "/").concat(projectOccupancyId)));

              case 1:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function SendIneligibleTransferEmail(_x2, _x3) {
        return _SendIneligibleTransferEmail.apply(this, arguments);
      }

      return SendIneligibleTransferEmail;
    }()
  }, {
    key: "GetNotReviewedCount",
    value: function () {
      var _GetNotReviewedCount = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee3() {
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                return _context3.abrupt("return", axios.get("/api/".concat(this._controller, "/GetNotReviewedCount")));

              case 1:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function GetNotReviewedCount() {
        return _GetNotReviewedCount.apply(this, arguments);
      }

      return GetNotReviewedCount;
    }()
  }]);

  return VawaRequest;
}(BaseData);

export default new VawaRequest();